/**
 * Geocoding utilities for converting city names to coordinates
 */

export interface GeocodingResult {
  city: string;
  state?: string;
  country: string;
  latitude: number;
  longitude: number;
  displayName: string;
}

interface NominatimResult {
  lat: string;
  lon: string;
  display_name: string;
  address?: {
    city?: string;
    town?: string;
    village?: string;
    state?: string;
    country?: string;
  };
  type?: string;
  addresstype?: string;
}

/**
 * Geocode a city name and return multiple possible matches
 */
export async function geocodeCityMultiple(
  cityName: string,
  limit: number = 5
): Promise<GeocodingResult[]> {
  try {
    const query = encodeURIComponent(cityName);
    const response = await fetch(
      `https://nominatim.openstreetmap.org/search?format=json&q=${query}&limit=${limit}&addressdetails=1`,
      {
        headers: {
          "User-Agent": "Museum Finder App",
        },
      }
    );

    if (!response.ok) {
      throw new Error("Geocoding request failed");
    }

    const data = (await response.json()) as NominatimResult[];

    if (!data || data.length === 0) {
      return [];
    }

    return data.map((result) => {
      const address = result.address || {};
      return {
        city: address.city || address.town || address.village || cityName,
        state: address.state,
        country: address.country || "Unknown",
        latitude: parseFloat(result.lat),
        longitude: parseFloat(result.lon),
        displayName: result.display_name,
      };
    });
  } catch (error) {
    console.error("Geocoding error:", error);
    return [];
  }
}
